module.exports = __webpack_public_path__ + "static/img/gf.87624ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/gf.png
// module id = g1Ra
// module chunks = 1